<div *ngIf="table.globalSearch">
  <nz-input-group [nzAddOnBefore]="prefixIconSearch">
    <input type="text" nz-input [(ngModel)]="globalFilterString" (keyup)="globalFilterChanged()"
      (change)="globalFilterCompleted()" placeholder="Buscar..." autocomplete="off" />
  </nz-input-group>
  <ng-template #prefixIconSearch>
    <i class="{{searchIcon}}"></i>
  </ng-template>
</div>

<div class="mb-2">
  <ng-container *ngFor="let actions of globalActions">
    <button type="button" nz-button (click)="tableGlobalAction(actionCode)">
      <i class=""></i><span>&nbsp; {{action.actionTitle}}</span>
    </button>
  </ng-container>
  <ng-container *ngFor="let actions of selectionActions">
    <button type="button" nz-button [disabled]="table.selectedRecords.length === 0"
      (click)="tableSelectionAction(actionCode)">
      <i class=""></i><span>&nbsp; {{action.actionTitle}}</span>
    </button>
  </ng-container>
</div>

<nz-table nzTemplateMode [nzLoading]="waiting" [nzSize]="'small'">
  <thead>
    <tr>
      <th *ngIf="selectable" id="selection" [nzSortFn]="selectionSortable" [nzShowSort]="selectionSortable" [nzSortDirections]="selectionColumn?.sortDirections"
        (nzSortOrderChange)="sortOrderHasChanged(selectionColumn, $event)" [nzAlign]="selectionColumn?.fieldAlignment">
        <ng-container *ngIf="!disabled && !selectionBackend">
          <button type="button" class="btn btn-icon btn-link" (click)="toggleSelectAll()">
            <i [class]="table.allSelected ? selectedIcon : unselectedIcon"></i>
          </button>
        </ng-container>
      </th>
      <ng-container *ngFor="let column of table.columns">
        <ng-container *ngIf="column.visible">
          <ng-container *ngIf="column.filterDef && column.filterDef.operators;else noFilterColumn">
            <ng-container *ngIf="column.filterDef.operators[0] === 'IN'">
              <th [nzSortFn]="column.sortable" [nzShowSort]="column.sortable" [id]="column.fieldCode" [nzSortDirections]="column.sortDirections"
                (nzSortOrderChange)="sortOrderHasChanged(column, $event)" [nzFilterMultiple]="true"
                [nzShowFilter]="column.filterDef" [nzFilterFn]="true" [nzAlign]="column.fieldAlignment"
                (nzFilterChange)="filterHasChanged(column, $event)" [nzFilters]="column.options">
                {{column.fieldTitle}}
              </th>
            </ng-container>
            <ng-container *ngIf="column.filterDef.operators[0] === 'HAS'">
              <th nzCustomFilter [id]="column.fieldCode" [nzAlign]="column.fieldAlignment" [nzSortFn]="column.sortable" [nzShowSort]="column.sortable"
                [nzSortDirections]="column.sortDirections" (nzSortOrderChange)="sortOrderHasChanged(column, $event)">
                {{column.fieldTitle}}
                <nz-filter-trigger [(nzVisible)]="column.filterVisible" [nzActive]="column.filter"
                  [nzDropdownMenu]="textSearch" (nzVisibleChange)="openSearch(column, $event)">
                  <i class="{{searchIcon}}"></i>
                </nz-filter-trigger>
              </th>
            </ng-container>
          </ng-container>

          <ng-template #noFilterColumn>
            <ng-container>
              <th [nzSortFn]="column.sortable" [nzShowSort]="column.sortable" [id]="column.fieldCode" [nzSortDirections]="column.sortDirections"
                (nzSortOrderChange)="sortOrderHasChanged(column, $event)" [nzAlign]="column.fieldAlignment">
                {{column.fieldTitle}}
              </th>
            </ng-container>
          </ng-template>
        </ng-container>
      </ng-container>
      <th *ngIf="hasActions && !disabled" id="actions" style="text-align: center; vertical-align: middle;">Acciones</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let record of visibleRecords">
      <td *ngIf="selectable" nowrap="nowrap" style="text-align: center;">
        <span *ngIf="disabled">
          <i [class]="record.selected ? selectedIcon : unselectedIcon"></i>
        </span>
        <button type="button" *ngIf="!disabled" nz-button class="btn btn-icon btn-link"
          (click)="tableSelectionToggle(record.recordId)">
          <i [class]="record.selected ? selectedIcon : unselectedIcon"></i><span>&nbsp;</span>
        </button>
      </td>

      <ng-template ngFor let-column [ngForOf]="table.columns">
        <td *ngIf="column.visible" [nzAlign]="column.fieldAlignment">
          <row-field [fieldCode]="column.fieldCode" [fieldType]="column.fieldType"
            [fieldValue]="record.recordData[column.fieldCode]">
          </row-field>
        </td>
      </ng-template>

      <td *ngIf="hasActions && !disabled" nowrap="nowrap" style="text-align: center;">
        <ng-template ngFor let-action [ngForOf]="inlineActions">
          <ng-container *ngIf="action?.visible">
            <row-action [action]="action" [recordData]="record.recordData" [recordId]="record.recordId"
              [disabled]="action?.disabled" (actionSelected)="tableActionSelected($event)">
            </row-action>
          </ng-container>
        </ng-template>
      </td>
    </tr>
  </tbody>
</nz-table>
<div class="mt-2" *ngIf="table.currentPage">
  <nz-pagination class="mb-3" *ngIf="table.totalRecordsNumber > table.recordsPerPage"
    [(nzPageIndex)]="table.currentPage" [nzTotal]="table.totalRecordsNumber" [nzPageSize]="table.recordsPerPage"
    (nzPageIndexChange)="changePage($event)">
  </nz-pagination>
</div>

<!-- Templates para el manejo de los filtros de las columnas de tablas -->

<nz-dropdown-menu #textSearch>
  <div class="ant-table-filter-dropdown">
    <div class="search-box">
      <input type="text" nz-input placeholder="Buscar" [(ngModel)]="activeSearchText" />
      <button nz-button nzSize="small" nzType="primary" (click)="search()" class="search-button">Buscar</button>
      <button nz-button nzSize="small" (click)="reset()">Borrar</button>
    </div>
  </div>
</nz-dropdown-menu>
